import { Claim, ClaimLogs } from "@/types/appTypes/claims";

import { request } from "../request";

export async function getClaimLogs(payload: {} | string | Claim, authToken: string): Promise<ClaimLogs> {
  const response = request<ClaimLogs>(
    {
      url: "/claim/get_logs",
      method: "POST",
      data: payload,
    },
    "adjudication",
    authToken,
  );

  return response;
}
